document.addEventListener('DOMContentLoaded', function() {
  const wrap = document.getElementById('freeship-announcement');
  const el = document.getElementById('shipping-threshold');
  if (!wrap || !el) return;

  // get Shopify's current currency settings
  const currencyCode = el.getAttribute('data-currency-code');

  // access the conversion rate
  const rate = window.Shopify?.currency?.rate || 1;

  // calculate the new amount (base * exchange rate)
  const baseAmount = parseFloat(el.getAttribute('data-base-amount')) / 100;
  const converted = baseAmount * rate;

  // format the new amount
  const formatted = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currencyCode,
    maximumFractionDigits: 0
  }).format(converted);

  // update the display
  el.innerHTML = `${formatted} ${currencyCode}`;

  requestAnimationFrame(() => wrap.classList.add('is-visible'));
});